"use client";

import { useEffect, useState } from "react";
import cnBind from "classnames/bind";
import { usePathname } from "next/navigation";
import { useTranslation } from "react-i18next";

import { startHref } from "@/components/marketing/launch";

import styles from "./StickyLaunchCta.module.scss";

const cx = cnBind.bind(styles);

/**
 * Нижняя кнопка запуска, когда hero CTA ушёл за экран.
 * Не перекрывает «Чат с агентом» — слева/по центру с учётом safe-area.
 */
export function StickyLaunchCta() {
    const { t } = useTranslation("common");
    const pathname = usePathname() ?? "/";
    const [visible, setVisible] = useState(false);
    const onHome = pathname === "/" || pathname === "";

    useEffect(() => {
        if (!onHome) {
            setVisible(false);
            return undefined;
        }

        const hero = document.querySelector("[data-hero]") || document.querySelector("section[class*='hero']");
        if (!hero) {
            setVisible(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                setVisible(!entry.isIntersecting);
            },
            { rootMargin: "-80px 0px 0px 0px", threshold: 0 },
        );
        observer.observe(hero);
        return () => observer.disconnect();
    }, [onHome]);

    if (!onHome || !visible) return null;

    return (
        <div className={cx("dock")} role="region" aria-label={t("home.stickyCta.ariaLabel")}>
            <a className={cx("btn")} href={startHref()}>
                {t("home.stickyCta.label")}
            </a>
        </div>
    );
}
